import { gql as e } from "@apollo/client";
const r = e`
  query GetClaimableRewardTypeInfosByRewardName($name: [String!]) {
    getClaimableRewardTypeInfosByRewardName(name: $name) {
      decimal
      rewardName
      rewardTokenAddress
      rewardType
      staticAssetKey
      tokenErcType
    }
  }
`;
export {
  r as default
};
//# sourceMappingURL=getCurrencyInfo.js.map
